import { useEffect, useState } from "react";

import NoDataFound from "../../_components/no-data-found/no-data-found.component";
import ActivitySlot from "../../_components/activity-slot/activity-slot.component";
import { ReactComponent as DownloadIcon } from "../../assets/icons/download.svg";
import { ReactComponent as BackArrowIcon } from "../../assets/icons/back_arrow_icon.svg";
import { ReactComponent as ForwardArrowIcon } from "../../assets/icons/forward_arrow_icon.svg";

import ApiService from "../../_services/ApiService";

import "./timetable.css";

interface TimeTableDataType {
  timeTableDataBeans: any[];
}

const DayColumn = ({
  weeklyRowsTemplate,
  width,
  timetableData,
  timeSlots,
  date,
}) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthNamesShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const daysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <div
      className="weekly-column"
      style={{
        gridTemplateRows: weeklyRowsTemplate,
      }}
    >
      <div className="day-details-weekly-timetable">
        <span>{`${date.getDate()} ${monthNamesShort[date.getMonth()]} ${date.getFullYear()}, ${daysShort[date.getDay()]} `}</span>
        {/* <span>{width < 750 ? daysShort[date.getDay()] : days[date.getDay()]}</span> */}
      </div>
      {timetableData.timeTableDataBeans?.reduce(
        (total, timeTableDataBean) =>
          Number(timeTableDataBean.dayOfMonth) === date.getDate() ? total + 1 : total,
        0
      ) === 0 ? (
        <NoDataFound text={"Free Slot"} />
      ) : (
        timetableData.timeTableDataBeans?.map((timeTableDataBean, i) =>
          Number(timeTableDataBean.dayOfMonth) === date.getDate()
            ? timeSlots.map((timeSlot) => {
                let isSlot = false;
                const slotData = timeTableDataBean.activitySlotDataBeans?.map(
                  (activitySlotDataBean, i) => {
                    if (timeSlot.exact === activitySlotDataBean.startTime) {
                      isSlot = true;
                      return (
                        <ActivitySlot
                          activitySlotDetail={activitySlotDataBean}
                          key={i}
                        />
                      );
                    } else {
                      return null;
                    }
                  }
                );

                if (isSlot === false)
                  return <div className="slot-data-container"><NoDataFound text="No data for this time slot" /></div>;

                return <div className="slot-data-container">{slotData}</div>;
              })
            : null
        )
      )}
    </div>
  );
};

const WeeklyTimetable = () => {
  const [curr, setCurr] = useState(new Date()); // get current date

  let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week

  const last = first + 6;
  console.log(first, last, "here");

  const [timetableData, setTimetableData] = useState<TimeTableDataType>(
    {} as TimeTableDataType
  );

  const [timeSlots, setTimeSlots] = useState([]);

  const convertDateFormat = (date) => {
    if (!date) return "";
    const givenDate = new Date(date);
    const yyyy = givenDate.getFullYear();
    let mm = givenDate.getMonth() + 1; // Months start at 0!
    let dd = givenDate.getDate();

    return `${dd}/${mm}/${yyyy}`;
  };

  const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");

    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    if (hours.toString().length === 1) hours = "0" + hours.toString();

    return `${hours}:${minutes}`;
  };

  const getTimeSlots = (timeTable) => {
    if (!timeTable.timeTableDataBeans?.length) return;

    const timeSet = new Set();

    timeTable.timeTableDataBeans?.forEach((timeTableDataBean) => {
      timeTableDataBean.activitySlotDataBeans?.forEach(
        (activitySlotDataBean) => {
          if (timeSet.has(activitySlotDataBean.startTime)) return;
          timeSet.add(activitySlotDataBean.startTime);
        }
      );
    });

    const timeSetArr = Array.from(timeSet);

    const timeSetArr24hr = [];

    for (const timeSlot of timeSetArr) {
      timeSetArr24hr.push({
        exact: timeSlot,
        converted24hr: convertTime12to24(timeSlot),
      });
    }

    timeSetArr24hr.sort((a, b) =>
      a.converted24hr.localeCompare(b.converted24hr)
    );

    setTimeSlots(timeSetArr24hr);
  };

  const fetchTimetableData = async () => {
    const startDate = convertDateFormat(new Date(curr).setDate(first));
    const endDate = convertDateFormat(new Date(curr).setDate(last));
    console.log(startDate, endDate, "here");
    // console.log(endDate,first>last?"true": false );
    let userId = JSON.parse(localStorage.getItem("currentUser")).userId;
    const requestData = {
      startDate,
      endDate,
      instructorId: null,
      userId: userId,
    };

    try {
      const response = await ApiService.getInstructorTimetable(requestData);
      getTimeSlots(response.data?.data);
      setTimetableData(response.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const printTimetable = () => {
    window.print();
  };

  useEffect(() => {
    fetchTimetableData();
  }, [curr]);

  const weeklyRowsTemplate = timeSlots.reduce(
    (rowString) => rowString + " auto",
    "40px"
  );

  const width = document.documentElement.clientWidth;

  const prevWeek = () => {
    let prevWeekDate = first - 7;
    const dateData = new Date(new Date(curr).setDate(prevWeekDate));
    console.log(dateData, "here");
    return setCurr(dateData);
  };

  const nextWeek = () => {
    const prevWeekDate = first + 7;
    const dateData = new Date(new Date(curr).setDate(prevWeekDate));
    console.log(dateData, "here");
    setCurr(dateData);
  };

  return (
    <section>
      <div className="weekly-timetable-download-wrapper">
        <div className="weekly-timetable-download" onClick={prevWeek}>
          <span className="donwload-icon-container">
            <BackArrowIcon />
          </span>
          Previous
        </div>
        <div className="weekly-timetable-download" onClick={printTimetable}>
          <span className="donwload-icon-container">
            <DownloadIcon />
          </span>
          Download
        </div>
        <div className="weekly-timetable-download" onClick={nextWeek}>
          Next
          <span className="donwload-icon-container">
            <ForwardArrowIcon />
          </span>
        </div>
      </div>
      <main className="weekly-timetable-container">
        <div
          className="weekly-column sticky-container"
          style={{
            gridTemplateRows: weeklyRowsTemplate,
          }}
        >
          <div className="day-details-weekly-timetable">
            <span>Start Time</span>
          </div>
          {timeSlots.map((timeSlot, i) => (
            <div key={i} className="day-details-weekly-timetable time-slot-div">
              <span>{timeSlot.exact}</span>
            </div>
          ))}
        </div>

        <DayColumn
          date={new Date(new Date(curr).setDate(first))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />

        <DayColumn
          date={new Date(new Date(curr).setDate(first + 1))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />

        <DayColumn
          date={new Date(new Date(curr).setDate(first + 2))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />

        <DayColumn
          date={new Date(new Date(curr).setDate(first + 3))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />

        <DayColumn
          date={new Date(new Date(curr).setDate(first + 4))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />

        <DayColumn
          date={new Date(new Date(curr).setDate(first + 5))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />

        <DayColumn
          date={new Date(new Date(curr).setDate(last))}
          weeklyRowsTemplate={weeklyRowsTemplate}
          timeSlots={timeSlots}
          width={width}
          timetableData={timetableData}
        />
      </main>
    </section>
  );
};

export default WeeklyTimetable;
